import { Component, Input, Output, EventEmitter, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import 'selectric';
import * as $ from 'jquery';

@Component({
  selector: 'app-selectric',
  templateUrl: './selectric.component.html',
  styleUrls: ['./selectric.component.scss']
})
export class SelectricComponent implements OnInit, AfterViewInit {
  @Input() title;
  @Input() options: {value: string, name: string}[];
  @Input() selectedIndex: number;
  @Input() idAttr: string;
  @Output() update = new EventEmitter<any>();
  $select;

  constructor(
    private _el: ElementRef
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.$select = $('[data-select]', this._el.nativeElement);

    if (this.$select) {
      this.$select.on('change', () => {
        const val = this.$select.val();
        this.update.emit(val);
      });
    }
  }
}
